var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"light-background vh-100",class:{ 'rtl iransans': _vm.$t('direction') === 'rtl', 'openSans': _vm.$t('direction') !== 'rtl'},attrs:{"id":"app"}},[_c('headerComp'),_c('div',{staticClass:"pages-layout"},[_c('TransitionPage',[_c('router-view')],1)],1),_c('footerComp')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }